/**
 * Created by avazquez on 08/25/2022.
 */

import {Player} from '../../services/player/player';

import {isNullOrUndefined} from 'util';

/**
 * Handle the list of Inactive players.  Because these
 * need to be output as an array of arrays that could
 * be variably sized, the information for it is encapsulated
 * here.
 */
export class Massroster {


  private columns: number = 3;
  private paginated: Player[][] = [];
  private players: Player[] = [];


  /**
   * Create it with the required Players array sorted
   * in alphabetical order by first name.
   *
   * @param players  The array of Players to use.
   * @param columns  The number of columns to paginate the results in.
   */
  constructor(players: Player[], columns: number) {

    this.players = players;
    this.columns = columns;
    this.paginated = this.paginate();

  }


  /**
   * For a given Player, return the Inactive table
   * entry for them.
   *
   * @param player    A Player object.
   * @returns {string}  A zero-length string or the formatted Player string.
   */
  public static getPlayer(player: Player) {

    if (0 === player.surname.length) {

      return '';

    }

    return player.firstname + ' ' + player.surname + ' - ' + player.position_title;

  }

  /**
   * Retrieve the current array of Players.
   *
   * @returns {Player[]}  The array of Players in use.
   */
  public getPlayers(): Player[] {
    return this.players;
  }

  /**
   * Retrieve the row-oriented array of
   * Player arrays.
   *
   * @returns {Player[][]}  The array of arrays representing rows of Players.
   */
  public getRows(): Player[][] {

    return this.paginated;

  }

  public clearPlayers(): void {
    this.paginated = [];
    this.players = [];
  }
  public getTotPlayers(): number {
    return this.players.length;
  }
  /**
   * Reformat the array so it will work in the column/row format
   * specified by the columns variable.
   *
   * @returns {Player[][]}  An array of Player arrays.
   */
  private paginate(): Player[][] {

    if (isNullOrUndefined(this.players) || 0 === this.players.length) {

      return [];

    }

    let sorted: Player[] = [];
    let column_length: number = Math.floor(this.players.length / this.columns);
    let remainder: number = 0;

    // Figure out how many to add to even the columns.
    if (this.players.length !== (column_length * this.columns)) {

      column_length = column_length + 1;
      remainder = (column_length * this.columns) - this.players.length;

    }

    let column: number = 0;
    let row: number = 0;
    let sort_index: number = 0;

    // Push the entries from the incoming array into the right spots in the outgoing array.
    for (let entry of this.players) {

      // Calculate where to insert this particular item in the output array.
      sort_index = (row * this.columns) + column;
      sorted[sort_index] = new Player(entry);
      row = row + 1;

      if (row === column_length) {

        column = column + 1;
        row = 0;

      }

    }

    // Add empty values to even out the array.
    if (0 !== remainder) {

      let id: number = -1;

      for (let x = 0; x < this.players.length + remainder; x++) {

        if (isNullOrUndefined(sorted[x])) {

          sorted[x] = new Player({'surname': '', 'firstname': '', 'position_title': '', 'id': id});
          id = id - 1;

        }

      }

    }

    // Create the array of row arrays and return it.
    let returnable: Player[][] = [];
    let counter: number = 0;
    let the_row: Player[] = [];

    for (let entry of sorted) {

      // Add this entry to the current row.
      the_row.push(entry);
      counter = counter + 1;

      if (counter === this.columns) {

        // Add the row to the output and set it up to do the next row.
        returnable.push(the_row);
        counter = 0;
        the_row = [];

      }

    }

    return returnable;

  }

}



// WEBPACK FOOTER //
// ./src/app/articles/massroster/massroster.ts